import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class EfileSubmissionManifestTableService {

  constructor(private http: HttpClient) { }

  // CRITICAL: Load submissions - use application/x-www-form-urlencoded
  loadSubmissions(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(baseUrl + '/loadJsonObject', urlEncoded.toString(), httpOptions);
  }

  // CRITICAL: Save submission manifest table data - use application/x-www-form-urlencoded
  saveSubmissionManifestTableData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(baseUrl, urlEncoded.toString(), httpOptions);
  }

  // Legacy alias from Gridsave mapping (AddEditSubMnfstFactory.updateSunMnfstTable)
  updateSunMnfstTable(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    return this.saveSubmissionManifestTableData(baseUrl, params, globalService, filterParams, rowData);
  }

  // CRITICAL: Delete submission manifest table data - use application/x-www-form-urlencoded
  deleteSubmissionManifestTableData(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    // CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(baseUrl, urlEncoded.toString(), httpOptions);
  }

  // Legacy alias from Gridsave mapping (AddEditSubMnfstFactory.deleteSubManifestRow)
  deleteSubManifestRow(
    baseUrl: string,
    params: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    return this.deleteSubmissionManifestTableData(baseUrl, params, globalService, filterParams, rowData);
  }
}
